module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBoldItalic.24c02e31.woff2";